import axiosClient from "../../utils/axiosClient"
import { ApplicationData, Campaign, CampaignData, Campaigns } from "../../types/sponsorships/campaigns"
import { apiConfigs } from "../../constants/apiConfigs";
import { CampaignFilters } from "../../redux-stores/slices/campaignSlice";

export const fetchCampaigns = async (page: number = 1, limit: number = 1000) : Promise<Campaigns> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CAMPAIGNS.url, {params: {page, limit}});
    return response.data as Campaigns
}

export const fetchCampaignsNew = async (payload: CampaignFilters) : Promise<Campaigns> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CAMPAIGNS.url, {params: payload});
    return response.data as Campaigns
}

export const fetchCampaign = async (campaignId: string) : Promise<CampaignData> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CAMPAIGN.url.replace('<campaignId>', campaignId));
    return response.data as CampaignData
}
export const fetchPublicCampaign = async (campaignId: string) : Promise<CampaignData> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CAMPAIGN_PUBLIC.url.replace('<campaignId>', campaignId));
    return response.data as CampaignData
}

export const fetchApplication = async (campaignId: string) : Promise<ApplicationData> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CAMPAIGN_APPLICATION.url.replace('<campaignId>', campaignId));
    return response.data as ApplicationData;
}

export const applyCampaign = async (campaign_id: string, social_account_id: string, coordinates: {lat?: number, lng?: number}, language_id?: string, referrer?: string, answers?: Record<string, string | number>) : Promise<any> => {
    const response = await axiosClient.post(apiConfigs.APPLY_CAMPAIGN.url.replace('<campaignId>', ''), {campaign_id, social_account_id, ...coordinates, ...(referrer ? {referrer} : {}), ...(language_id ? {language_id} : {}), ...(answers ? {answers} : {})});
    return response.data;
}

export const fetchInvitedCampaigns = async () : Promise<Campaign[]> => {
    const response = await axiosClient.get(apiConfigs.FETCH_INVITED_CAMPAIGNS.url);
    return response.data.items as Campaign[]
}